import { type IZendeskService } from './zendesk.service';

export class ZendeskMocked implements IZendeskService {
  public setLocale(_: string): void {}

  public identify(_: any): void {}

  public hide(): void {}

  public show(): void {}

  public activate(): void {}

  public setHelpCenterSuggestions(_: any): void {}

  public setAuthenticate(): void {}
}
